export default (event=null, initialize=true, margin=0) => ({
    imageBox: {},
    document: {},
    element: null,

    init() {
        this.document = document.documentElement;
        this.element = document.querySelector(this.$el.dataset.element) ?? this.$el.parentElement;

        if(initialize) {
            this.createBox(this.element)
        }

        if(event) {
            window.addEventListener(`${event}::show`, ({detail}) => {
                if(_.has(detail, 'document')) {
                    this.document = detail.document
                }

                this.createBox(detail.target)
                this.mountTooltip(detail.url, detail.target, _.get(detail, 'name'))
            });

            window.addEventListener(`${event}::close`, () => this.close());
        }
    },

    createBox(element) {
        this.imageBox = document.createElement("div");
        this.imageBox.innerHTML = "";

        this.imageBox.classList.add(
            "absolute",
            "border",
            "border-gray-200",
            "z-50",
            "image-tooltip",
            "overflow-hidden",
            "pointer-events-none",
            "text-center",
            "align-middle",
            "bg-gray-100",
            "aspect-h-15",
            "rounded-lg",
            "hidden"
        );

        this.imageBox.style.maxWidth = "300px";
        this.imageBox.style.maxHeight = "300px";

        const loading = document.createElement("div");
        loading.className="animate-pulse loading bg-gray-200 w-full h-full rounded-lg absolute top-0 left-0 z-10";

        this.imageBox.appendChild(loading);
        element.classList.add("relative");
    },

    show(imageUrl, imageName=null) {
        this.mountTooltip(imageUrl, this.element, imageName);
    },

    mountTooltip(imageUrl, element, imageName=null) {
        const screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;

        if (screenWidth <= 800) {
            return;
        }

        const img = document.createElement("img");
        const span = document.createElement("span");

        span.innerText = String(imageName).toLowerCase();
        span.classList.add("absolute", "bottom-0", "left-0", "z-50", "text-2xs");
        span.classList.add("bg-gray-800/40", "p-1", "text-white");

        img.src = imageUrl;
        
        img.onerror = () => {
            img.alt = 'Image Not Found';
        }

        img.classList.add("m-auto", "w-full", "pointer-events-none", "object-contain");

        this.imageBox.classList.remove("hidden");

        this.imageBox.style.top = "-4rem";
        this.imageBox.style.bottom = null;

        this.imageBox.style.height = "300px";
        this.imageBox.style.width = "300px";

        element.appendChild(this.imageBox);

        if(_.has(this.$el.dataset, 'element')) {
            this.moveImageElement();
        } else {
            this.moveImageBox();
        }

        element.querySelectorAll('img')?.forEach((element) => element.remove());
        this.imageBox.appendChild(img);

        if(imageName) {
            this.imageBox.appendChild(span);
        }

        img.onload = () => {
            element.querySelector('.loading')?.remove();

            if(img.naturalHeight > img.naturalWidth) {
                const width = img.naturalWidth * 300 / img.naturalHeight;

                this.imageBox.style.height = "300px";
                this.imageBox.style.width = width + 'px';
            } else {
                const height = img.naturalHeight * 300 / img.naturalWidth;

                this.imageBox.style.width = "300px";
                this.imageBox.style.height = height + "px";
            }

            this.$nextTick(() => this.checkImagePosition(img));
        };

        this.checkImagePosition(img);
    },

    checkImagePosition(img) {
        let containerId = _.get(this.$el.dataset, 'containerId');
        const imgPos = img.parentElement?.getBoundingClientRect();

        if(_. has(this.$el.dataset, 'element') && img.parentElement && imgPos.top + imgPos.height > window.innerHeight) {
            img.parentElement.style.top = Math.max(5, window.innerHeight - imgPos.height) + "px";
        }

        if(containerId) {
            const {top, left} = this.getBoundingClientRectParent(img, document.getElementById(containerId));

            if(top < 0) {
                img.parentElement.style.top = imgPos.top - (top * -1) + "px";
            }

            if(left < 0) {
                img.parentElement.style.left = imgPos.left - (left * -1) + "px";
            }
        }
    },

    getBoundingClientRectParent(element, parent) {
        const relativePos = {};
        const parentPos = parent.getBoundingClientRect();
        const childPos  = element.getBoundingClientRect();

        relativePos.top    = childPos.top - parentPos.top,
        relativePos.right  = childPos.right - parentPos.right,
        relativePos.bottom = childPos.bottom - parentPos.bottom,
        relativePos.left   = childPos.left - parentPos.left;

        return relativePos;
    },

    moveImageBox() {
        const documentBounding = this.document.getBoundingClientRect();
        const imageBoxBounding = this.imageBox.getBoundingClientRect();

        let position = {
            bottom: imageBoxBounding.bottom + documentBounding.top,
            top: imageBoxBounding.top - documentBounding.top,
            y: imageBoxBounding.y - documentBounding.y,
            x: imageBoxBounding.x - documentBounding.x
        }

        const positionCalc = `calc(80% + ${margin}px)`

        window.innerWidth - position.x <= window.innerWidth * 0.35
            ? (this.imageBox.style.right = positionCalc)
            : (this.imageBox.style.left = positionCalc);

        if (position.bottom > this.document.offsetHeight) {
            this.imageBox.style.top = null;
            this.imageBox.style.bottom =
                position.bottom * 0.9 -
                this.document.offsetHeight +
                "px";
        } else if (position.y < 0) {
            const y = position.top * -1;
            this.imageBox.style.bottom = null;
            this.imageBox.style.top = y - 60 + "px";
        }
    },

    moveImageElement() {
        const documentBounding = this.$el.getBoundingClientRect();

        this.imageBox.style.left = `${documentBounding.left + documentBounding.width}px`;
        this.imageBox.style.top = `${documentBounding.top + documentBounding.height}px`;
    },

    close() {
        this.imageBox.remove();
    },
});
